import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pair } from 'client/voladeum/pairs/types';
import { SLICE } from 'ducks/slice';

import { pair_default } from './defaults';

const initialState: Pair = { ...pair_default };

export const pairSlice = createSlice({
  name: SLICE.PAIR,
  initialState,
  reducers: {
    setPair: (_state, action: PayloadAction<Pair>) => {
      return action.payload;
    },
    clearPair: () => {
      return initialState;
    },
  },
});

export const { setPair, clearPair } = pairSlice.actions;

export default pairSlice.reducer;
